import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material';

import * as fromRoot from '../../../reducers';
import * as fromAfbApi from '../../../afb-api/reducers';
import * as fromFloorPlanEditor from '../../reducers/index';
import {select, Store} from '@ngrx/store';
import {GetOrganizationFloors} from '../../../afb-api/actions/floor-plan.actions';
import {Observable, Subscription} from 'rxjs';
import {DeselectFloor, ResetFloorImage} from '../../actions/floor-plan-editor-view.actions';
import {RemoveAllDeviceMarker, SetInitialDeviceMarkers} from '../../actions/floor-plan-editor-device-marker.actions';
import {Floor, FloorPlanDevice} from '../../../afb-api/models/floor';
import {DeviceMarker} from '../../../floor-plan-shared/models/device-marker';
import {distinctUntilChanged, filter} from 'rxjs/operators';
import {OrganizationWithToken} from '../../../core/models/core';

@Component({
  selector: 'awair-floor-plan-editor',
  templateUrl: './floor-plan-editor.component.html',
  styleUrls: ['./floor-plan-editor.component.scss']
})

export class FloorPlanEditorComponent implements OnInit, OnDestroy {

  selectedOrganization$: Observable<OrganizationWithToken> = this.rootStore.pipe(
    select(fromRoot.selectedOrganization),
    filter((selectedOrganization: OrganizationWithToken) => selectedOrganization != null)
  );
  isFloorPlanEdited$: Observable<boolean> = this.floorPlanEditorStore.pipe(
    select(fromFloorPlanEditor.isFloorPlanEdited)
  );
  selectedFloor$: Observable<Floor> = this.floorPlanEditorStore.pipe(
    select(fromFloorPlanEditor.selectedFloor),
    distinctUntilChanged((previous: Floor, current: Floor) => previous && current && previous.id === current.id)
  );

  private selectedOrganizationSubscription: Subscription;
  private selectedFloorSubscription: Subscription;

  constructor(private myDialogRef: MatDialogRef<FloorPlanEditorComponent>,
              private rootStore: Store<fromRoot.State>,
              private afbApiStore: Store<fromAfbApi.State>,
              private floorPlanEditorStore: Store<fromFloorPlanEditor.State>) {
  }

  ngOnInit() {
    this.selectedOrganizationSubscription = this.selectedOrganization$.subscribe((selectedOrganization: OrganizationWithToken) => {
      this.afbApiStore.dispatch(new GetOrganizationFloors({organizationToken: selectedOrganization.token}));
    });

    this.selectedFloorSubscription = this.selectedFloor$.subscribe((floor: Floor) => {
      const floorPlanDevices: FloorPlanDevice[] = floor && floor.floorPlan && floor.floorPlan.devices;

      if (floorPlanDevices) {
        // DeviceMarker and FloorPlanDevice have same properties
        this.floorPlanEditorStore.dispatch(new SetInitialDeviceMarkers(<DeviceMarker[]>floorPlanDevices));
      } else {
        // When there's no device markers in the floor, set initial device markers to empty to
        // prevent removedDeviceUuid to enter map when map is uploaded
        this.floorPlanEditorStore.dispatch(new SetInitialDeviceMarkers([]));
      }
    });
  }

  ngOnDestroy() {
    if (this.selectedOrganizationSubscription) {
      this.selectedOrganizationSubscription.unsubscribe();
    }
    if (this.selectedFloorSubscription) {
      this.selectedFloorSubscription.unsubscribe();
    }
  }

  onClose(clearAll: boolean): void {
    if (clearAll) {
      this.floorPlanEditorStore.dispatch(new DeselectFloor());
      this.floorPlanEditorStore.dispatch(new RemoveAllDeviceMarker());
      this.floorPlanEditorStore.dispatch(new ResetFloorImage());
    }

    this.myDialogRef.close();
  }
}
